/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/react-in-jsx-scope */
"use client"

// App.js
import { useState, useEffect, useRef, useCallback } from "react"
import axios from "axios"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import AuthPage from "./AuthPage"
import "./App.css"
import { FaRegCopy, FaCheck, FaThumbsUp, FaThumbsDown } from "react-icons/fa"
import PropTypes from "prop-types"
import AudioControls from "./AudioControls"

const API_URL = process.env.REACT_APP_API_URL || "/api"

// Configure axios defaults
axios.defaults.baseURL = API_URL
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const WelcomePage = ({ onAddNotes, user, setShowWelcome, loadChatSession, setNoteStatus }) => {
  const [notebooks, setNotebooks] = useState([])
  const [isCreatingNotebook, setIsCreatingNotebook] = useState(false)
  const [newNotebookTitle, setNewNotebookTitle] = useState("")
  const [selectedNotebook, setSelectedNotebook] = useState(null)

  const fetchNotebooks = useCallback(async () => {
    try {
      const response = await axios.get("/notebooks")
      if (response.data.status === "success") {
        setNotebooks(response.data.notebooks)
       
        // If there's a previously selected notebook, highlight it
        const lastNotebookId = localStorage.getItem("lastNotebookId")
        if (lastNotebookId) {
          const notebook = response.data.notebooks.find(n => n.id === parseInt(lastNotebookId))
          if (notebook) {
            setSelectedNotebook(notebook)
          }
        }
      }
    } catch (error) {
      console.error("Error fetching notebooks:", error)
      setNoteStatus?.({
        show: true,
        message: "Failed to fetch notebooks",
        type: "error"
      })
    }
  }, [setNoteStatus])

  useEffect(() => {
    fetchNotebooks()
  }, [fetchNotebooks])

  const createNotebook = async () => {
    try {
      setIsCreatingNotebook(true)
      const response = await axios.post('/notebooks', {
        title: newNotebookTitle || 'New Notebook',
        chat_history: []
      })

      if (response.data.status === 'success') {
        const newNotebook = response.data.notebook
        setNotebooks(prev => [...prev, newNotebook])
        setNewNotebookTitle('')
       
        // Automatically select the new notebook
        await loadChatSession(newNotebook.id, newNotebook.title)
      } else {
        setNoteStatus?.({
          show: true,
          message: "Failed to create notebook",
          type: "error"
        })
      }
    } catch (error) {
      console.error("Error creating notebook:", error)
      setNoteStatus?.({
        show: true,
        message: "Failed to create notebook",
        type: "error"
      })
    } finally {
      setIsCreatingNotebook(false)
    }
  }

  const handleNotebookClick = async (notebook) => {
    try {
      setSelectedNotebook(notebook)
      await loadChatSession(notebook.id, notebook.title)
    } catch (error) {
      console.error("Error loading notebook:", error)
      setNoteStatus?.({
        show: true,
        message: "Failed to load notebook",
        type: "error"
      })
    }
  }

  const handleDeleteNotebook = async (notebookId) => {
    try {
      const response = await axios.delete(`/notebooks/${notebookId}`)
      if (response.data.status === "success") {
        await fetchNotebooks()
      }
    } catch (error) {
      console.error("Error deleting notebook:", error)
    }
  }

  return (
    <div className="welcome-container">
      <header className="welcome-header">
        <div className="welcome-logo" onClick={() => setShowWelcome(true)} style={{ cursor: 'pointer' }}>
          <img
            src="https://media.licdn.com/dms/image/v2/D560BAQGF6NHHgadKYg/company-logo_200_200/company-logo_200_200/0/1707117426803?e=2147483647&v=beta&t=HsOE6G-9_879EDgNxvhQdr9Sgk2Tyyn_qUY1jV6jdXA"
            alt="Synapze Logo"
          />
          <h1>SynapzeLM</h1>
        </div>
        {/* <div className="user-profile">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiByeD0iMjQiIGZpbGw9IiMwMDRBQUQiLz4KPGVsbGlwc2UgY3g9IjY0IiBjeT0iNDMuNjM2NCIgcng9IjIwLjM2MzYiIHJ5PSIyMC4zNjM2IiBmaWxsPSIjQzVFMEZCIi8+CjxlbGxpcHNlIGN4PSI2NCIgY3k9IjEwNC43MjciIHJ4PSIzNS42MzY0IiByeT0iMjMuMjcyNyIgZmlsbD0iIzIwOTJFRCIvPgo8L3N2Zz4K"
            alt="User Profile"
          />
        </div> */}
      </header>

      <div className="welcome-content">
        <h1 className="welcome-title">Welcome to SynapzeLM</h1>
        <div className="create-notebook-form">
          <input
            type="text"
            value={newNotebookTitle}
            onChange={(e) => setNewNotebookTitle(e.target.value)}
            placeholder="Enter notebook title"
            className="notebook-title-input"
          />
          <button
            className="add-notes-btn"
            onClick={createNotebook}
            disabled={isCreatingNotebook}
          >
            {isCreatingNotebook ? "Creating..." : "Create New Notebook"}
          </button>
        </div>
      </div>

      {notebooks.length > 0 && (
        <div className="notebooks-section">
          <h2>Your Notebooks</h2>
          <div className="notebooks-grid">
            {notebooks.map((notebook) => (
              <div
                key={notebook.id}
                className={`notebook-card ${selectedNotebook?.id === notebook.id ? "selected" : ""}`}
                onClick={() => handleNotebookClick(notebook)}
              >
                <div className="notebook-header">
                  <h3>{notebook.title}</h3>
                  <span className="notebook-date">
                    {new Date(notebook.created_at).toLocaleDateString()}
                  </span>
                </div>
                <div className="notebook-actions">
                  <button
                    className="delete-notebook-btn"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleDeleteNotebook(notebook.id)
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

     
    </div>
  )
}

WelcomePage.propTypes = {
  onAddNotes: PropTypes.func.isRequired,
  user: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.number,
  }),
  setShowWelcome: PropTypes.func.isRequired,
  loadChatSession: PropTypes.func.isRequired,
  setNoteStatus: PropTypes.func
}

function App() {
  // Modify the ChatTabContent component to remove inline audio players
  const ChatTabContent = ({
    chatHistory,
    audioRefs,
    isPlaying,
    toggleAudioPlayback,
    stopAudioPlayback,
    setActiveAudioIndex,
  }) => {
    // State to track which chat item has been copied (keyed by index)
    const [copied, setCopied] = useState({})
    // State to track feedback for each message (keyed by index)
    const [feedback, setFeedback] = useState({})
    // State to track view timers for implicit feedback (keyed by response_id)
    const viewTimersRef = useRef({})
    // State to track scroll depths (keyed by response_id)
    const scrollDepthsRef = useRef({})
    // State to track if view has been tracked (keyed by response_id)
    const viewTrackedRef = useRef({})

    const handleCopy = async (text, index, responseId) => {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          // Mark this message as copied
          setCopied((prev) => ({ ...prev, [index]: true }))
          // Reset the flag after 2 seconds
          setTimeout(() => {
            setCopied((prev) => ({ ...prev, [index]: false }))
          }, 2000)
          
          // Track copy event for implicit feedback
          if (responseId) {
            trackImplicitEvent(responseId, "copy", {
              text_length: text.length,
              timestamp: new Date().toISOString()
            })
          }
        })
        .catch((err) => {
          console.error("Error copying text: ", err)
        })
    }

    const handleFeedback = async (index, feedbackType, userMessage, aiResponse) => {
      try {
        // Update local state immediately for better UX
        setFeedback((prev) => ({ ...prev, [index]: feedbackType }))

        // Send feedback to backend
        await axios.post("/feedback", {
          message: userMessage,
          response: aiResponse,
          feedback_type: feedbackType,
          chat_id: null, // You can add chat_id if needed
          rating: null,
          comment: null,
        })

        console.log(`Feedback submitted: ${feedbackType} for message ${index}`)
      } catch (error) {
        console.error("Error submitting feedback:", error)
        // Revert the feedback state on error
        setFeedback((prev) => {
          const newState = { ...prev }
          delete newState[index]
          return newState
        })
        // Optionally show an error message to the user
        alert("Failed to submit feedback. Please try again.")
      }
    }

    // Implicit feedback tracking functions
    const trackImplicitView = async (responseId, userMessage, aiResponse) => {
      if (!responseId) return
      try {
        await axios.post("/feedback/implicit/track-view", {
          response_id: responseId,
          message: userMessage,
          response: aiResponse,
          chat_id: null,
        })
      } catch (error) {
        console.error("Error tracking view:", error)
      }
    }

    const trackImplicitEvent = async (responseId, eventType, eventData = {}) => {
      if (!responseId) return
      try {
        await axios.post("/feedback/implicit/event", {
          response_id: responseId,
          event_type: eventType,
          event_data: eventData,
        })
      } catch (error) {
        console.error(`Error tracking ${eventType}:`, error)
      }
    }

    const trackFollowUp = async (previousResponseId, isSameQuestion, isFollowUp, timeSinceResponse) => {
      if (!previousResponseId) return
      try {
        await axios.post("/feedback/implicit/follow-up", {
          previous_response_id: previousResponseId,
          is_same_question: isSameQuestion,
          is_follow_up: isFollowUp,
          time_since_response: timeSinceResponse,
        })
      } catch (error) {
        console.error("Error tracking follow-up:", error)
      }
    }

    return (
      <div className="chat-content">
        <div className="chat-messages-container">
          {chatHistory.map(({ user, ai }, i) => {
            // Determine the AI response text
            let responseText =
              ai && typeof ai === "object" && ai.text
                ? ai.text
                : typeof ai === "string"
                  ? ai
                  : "Waiting for response..."

            // Remove summary section from response
            responseText = removeSummarySection(responseText)

            return (
              <div key={i} className="chat-exchange">
                <div className="user-message">
                  <strong>You:</strong> {user}
                </div>

                <div className="ai-response">
                  {editingIndex === i ? (
                    <div className="edit-response-container">
                      <textarea
                        className="edit-response-textarea"
                        value={editedResponse}
                        onChange={(e) => setEditedResponse(e.target.value)}
                      />
                      <div className="edit-actions">
                        <button className="save-edit-btn" onClick={() => saveEditedResponse()}>
                          Save
                        </button>
                        <button className="cancel-edit-btn" onClick={() => cancelEdit()}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <ResponseTracker
                      responseId={ai?.response_id}
                      userMessage={user}
                      aiResponse={responseText}
                      onViewTracked={trackImplicitView}
                      onScrollTracked={trackImplicitEvent}
                    >
                      <div className="ai-text">
                        <div className="response-content">
                          <ReactMarkdown
                            rehypePlugins={[rehypeRaw]}
                            components={{
                              // eslint-disable-next-line react/prop-types
                              a: ({ href, onClick, ...rest }) => (
                                <a
                                  href={href}
                                  {...rest}
                                  onClick={(e) => {
                                    if (ai?.response_id && href) {
                                      trackImplicitEvent(ai.response_id, "click_source", {
                                        url: href,
                                        timestamp: new Date().toISOString()
                                      })
                                    }
                                    if (onClick) onClick(e)
                                  }}
                                />
                              )
                            }}
                          >
                            {responseText}
                          </ReactMarkdown>
                        </div>
                        {ai && ai.source_document && (
                          <div className="source-document-info">
                            <span>Notebook: {ai.source_document}</span>
                          </div>
                        )}
                        <div className="response-actions">
                          {copied[i] ? (
                            <button className="action-button" title="Copied!">
                              <FaCheck />
                            </button>
                          ) : (
                            <button
                              className="action-button"
                              title="Copy to clipboard"
                              onClick={() => handleCopy(responseText, i, ai?.response_id)}
                            >
                              <FaRegCopy />
                            </button>
                          )}
                        <button className="action-button" title="Edit response" onClick={() => handleEditResponse(i)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                          </svg>
                        </button>
                        {ai && ai.audio_url && (
                          <button className="action-button" title="Play audio" onClick={() => setActiveAudioIndex(i)}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                              <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
                            </svg>
                          </button>
                        )}
                        <button
                          className={`action-button feedback-button ${feedback[i] === "thumbs_up" ? "active" : ""}`}
                          title="Thumbs up"
                          onClick={() => handleFeedback(i, "thumbs_up", user, responseText)}
                        >
                          <FaThumbsUp style={{ color: feedback[i] === "thumbs_up" ? "#4CAF50" : "currentColor" }} />
                        </button>
                        <button
                          className={`action-button feedback-button ${feedback[i] === "thumbs_down" ? "active" : ""}`}
                          title="Thumbs down"
                          onClick={() => handleFeedback(i, "thumbs_down", user, responseText)}
                        >
                          <FaThumbsDown style={{ color: feedback[i] === "thumbs_down" ? "#f44336" : "currentColor" }} />
                        </button>
                      </div>
                    </div>
                    </ResponseTracker>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  // Component to track implicit feedback for each response
  const ResponseTracker = ({ responseId, userMessage, aiResponse, onViewTracked, onScrollTracked, children }) => {
    const responseRef = useRef(null)
    const viewStartTimeRef = useRef(null)
    const scrollDepthRef = useRef(0)
    const viewTrackedRef = useRef(false)
    const durationIntervalRef = useRef(null)

    useEffect(() => {
      if (!responseId || !responseRef.current) return

      // Track initial view
      if (!viewTrackedRef.current) {
        viewTrackedRef.current = true
        viewStartTimeRef.current = Date.now()
        onViewTracked(responseId, userMessage, aiResponse)

        // Start tracking view duration
        durationIntervalRef.current = setInterval(() => {
          if (viewStartTimeRef.current) {
            const duration = Date.now() - viewStartTimeRef.current
            onScrollTracked(responseId, "view_duration", { duration })
          }
        }, 5000) // Update every 5 seconds
      }

      // Track scroll depth
      const handleScroll = () => {
        if (!responseRef.current) return
        
        const element = responseRef.current
        const rect = element.getBoundingClientRect()
        const windowHeight = window.innerHeight || document.documentElement.clientHeight
        
        // Calculate how much of the element is visible
        const visibleTop = Math.max(0, -rect.top)
        const visibleBottom = Math.min(rect.height, windowHeight - rect.top)
        const visibleHeight = Math.max(0, visibleBottom - visibleTop)
        const scrollDepth = Math.min(1.0, visibleHeight / rect.height)
        
        // Only update if scroll depth increased
        if (scrollDepth > scrollDepthRef.current) {
          scrollDepthRef.current = scrollDepth
          onScrollTracked(responseId, "scroll", { depth: scrollDepth })
        }
      }

      // Use IntersectionObserver to track when response is visible
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              handleScroll()
            }
          })
        },
        { threshold: [0, 0.25, 0.5, 0.75, 1.0] }
      )

      if (responseRef.current) {
        observer.observe(responseRef.current)
        window.addEventListener("scroll", handleScroll, { passive: true })
      }

      return () => {
        if (durationIntervalRef.current) {
          clearInterval(durationIntervalRef.current)
        }
        observer.disconnect()
        window.removeEventListener("scroll", handleScroll)
        
        // Send final view duration when component unmounts
        if (viewStartTimeRef.current) {
          const finalDuration = Date.now() - viewStartTimeRef.current
          onScrollTracked(responseId, "view_duration", { duration: finalDuration })
        }
      }
    }, [responseId, userMessage, aiResponse, onViewTracked, onScrollTracked])

    return <div ref={responseRef}>{children}</div>
  }

  // PropTypes for ResponseTracker
  ResponseTracker.propTypes = {
    responseId: PropTypes.string,
    userMessage: PropTypes.string,
    aiResponse: PropTypes.string,
    onViewTracked: PropTypes.func.isRequired,
    onScrollTracked: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  }

  // Update the ChatTabContent PropTypes
  ChatTabContent.propTypes = {
    chatHistory: PropTypes.arrayOf(
      PropTypes.shape({
        user: PropTypes.string,
        ai: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            text: PropTypes.string,
            audio_url: PropTypes.string,
          }),
        ]),
      }),
    ).isRequired,
    audioRefs: PropTypes.shape({
      current: PropTypes.object,
    }).isRequired,
    isPlaying: PropTypes.object.isRequired,
    toggleAudioPlayback: PropTypes.func.isRequired,
    stopAudioPlayback: PropTypes.func.isRequired,
    setActiveAudioIndex: PropTypes.func.isRequired,
  }
  // Authentication states
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [user, setUser] = useState(null)

  // Document processing states
  const [url, setUrl] = useState("")
  const [files, setFiles] = useState([])
  const [noteText, setNoteText] = useState("")
  const [modelChoice, setModelChoice] = useState("gemma-4b")
  const [language, setLanguage] = useState("en")
  const [summaries, setSummaries] = useState("")
  const [individualSummaries, setIndividualSummaries] = useState([])
  const [suggestedQuestions, setSuggestedQuestions] = useState([])
  const [filePaths, setFilePaths] = useState([])
  const [generateAudio, setGenerateAudio] = useState(false)
  const [noteStatus, setNoteStatus] = useState({ show: false, message: "", type: "" })

  // Chat states
  const [chatHistory, setChatHistory] = useState([])
  const [message, setMessage] = useState("")
  // eslint-disable-next-line no-unused-vars
  const [sourceGuide, setSourceGuide] = useState("")
  const [isProcessing, setIsProcessing] = useState(false)
  const [isPlaying, setIsPlaying] = useState({})
  const audioRefs = useRef({})

  // Notebook states
  const [notebookName, setNotebookName] = useState("Untitled Notebook")
  const [notebookId, setNotebookId] = useState(null)
  const [isEditingNotebookName, setIsEditingNotebookName] = useState(false)
  const [loadedChatSessions, setLoadedChatSessions] = useState([])

  // UI states
  const [activeTab, setActiveTab] = useState("summary")
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([])
  const [showFileMenu, setShowFileMenu] = useState(null)
  const [showAddSourcesModal, setShowAddSourcesModal] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [showWelcome, setShowWelcome] = useState(true)
  const [renamingFile, setRenamingFile] = useState(null)
  const [newFileName, setNewFileName] = useState("")
  const [activeAudioIndex, setActiveAudioIndex] = useState(null)

  // Refs
  const chatHistoryRef = useRef(null)
  const fileInputRef = useRef(null)
  const modalContentRef = useRef(null)
  const renameInputRef = useRef(null)

  const resetNotebookState = useCallback(() => {
    setChatHistory([])
    setFiles([])
    setFilePaths([])
    setSummaries("")
    setIndividualSummaries([])
    setSuggestedQuestions([])
  }, [])

  // Implicit feedback tracking functions (accessible from App component)
  const trackImplicitEvent = async (responseId, eventType, eventData = {}) => {
    if (!responseId) return
    try {
      await axios.post("/feedback/implicit/event", {
        response_id: responseId,
        event_type: eventType,
        event_data: eventData,
      })
    } catch (error) {
      console.error(`Error tracking ${eventType}:`, error)
    }
  }

  const trackFollowUp = async (previousResponseId, isSameQuestion, isFollowUp, timeSinceResponse) => {
    if (!previousResponseId) return
    try {
      await axios.post("/feedback/implicit/follow-up", {
        previous_response_id: previousResponseId,
        is_same_question: isSameQuestion,
        is_follow_up: isFollowUp,
        time_since_response: timeSinceResponse,
      })
    } catch (error) {
      console.error("Error tracking follow-up:", error)
    }
  }

  const loadChatSession = useCallback(async (notebookId, notebookTitle) => {
    try {
      setIsProcessing(true)
      setNotebookId(notebookId)
      setNotebookName(notebookTitle)
      setActiveTab("chat")
      setShowWelcome(false)

      // Save the current notebook ID to localStorage
      localStorage.setItem("lastNotebookId", notebookId.toString())

      // Load all notebook data
      const response = await axios.get(`/notebooks/${notebookId}/chats`)
      if (response.data.status === "success") {
        // Set chat history
        const formattedHistory = response.data.chat_history.map(chat => ({
          user: chat.user,
          ai: {
            text: chat.ai?.text || chat.ai || null,
            audio_url: chat.ai?.audio_url || null,
            source_document: chat.ai?.source_document || notebookTitle
          }
        }))
        setChatHistory(formattedHistory)

        // Set files
        setFiles([])  // Clear existing files
        setFilePaths(response.data.files || [])

        // Set summaries
        setSummaries(response.data.summaries || "")
        setIndividualSummaries(response.data.individual_summaries || [])
        setSuggestedQuestions(response.data.suggested_questions || [])

      } else {
        resetNotebookState()
      }
    } catch (error) {
      console.error("Error loading notebook data:", error)
      setNoteStatus({
        show: true,
        message: "Failed to load notebook data",
        type: "error"
      })
      resetNotebookState()
    } finally {
      setIsProcessing(false)
    }
  }, [resetNotebookState])

  // Update the authentication check effect
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token")
      if (token) {
        try {
          const response = await axios.get("/user/me")
          setUser(response.data)
          setIsAuthenticated(true)
         
          // Fetch notebooks after authentication
          const notebooksResponse = await axios.get("/notebooks")
          if (notebooksResponse.data.status === "success") {
            const notebooks = notebooksResponse.data.notebooks
           
            // If there's a previously selected notebook in localStorage, load it
            const lastNotebookId = localStorage.getItem("lastNotebookId")
            if (lastNotebookId && notebooks.some(n => n.id === parseInt(lastNotebookId))) {
              const notebook = notebooks.find(n => n.id === parseInt(lastNotebookId))
              await loadChatSession(notebook.id, notebook.title)
            } else {
              setShowWelcome(true)
            }
          }
        } catch (error) {
          console.error("Auth check failed:", error)
          localStorage.removeItem("token")
          localStorage.removeItem("lastNotebookId")
          setIsAuthenticated(false)
          setUser(null)
        }
      }
    }
    checkAuth()
  }, [loadChatSession])

  // Scroll to bottom of chat history when it updates
  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight
    }
  }, [chatHistory])

  // Hide note status message after 3 seconds
  useEffect(() => {
    if (noteStatus.show) {
      const timer = setTimeout(() => {
        setNoteStatus({ show: false, message: "", type: "" })
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [noteStatus])

  const handleLogout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("lastNotebookId")
    setIsAuthenticated(false)
    setUser(null)
    resetNotebookState()
    setShowWelcome(true)
  }

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFiles((prevFiles) => [...prevFiles, ...Array.from(e.target.files)])
    }
  }

  const handleAddNote = async (noteText) => {
    if (!noteText || !noteText.trim()) {
      setNoteStatus({
        show: true,
        message: "Note text cannot be empty.",
        type: "error",
      });
      return { success: false, message: "Note text cannot be empty." };
    }

    try {
      setIsProcessing(true);
      const addResponse = await axios.post("/add_note", {
        note_text: noteText.trim(),
        files: filePaths,
      });

      if (!addResponse.data.file_path) {
        throw new Error("No file path returned from server");
      }

      const newFilePath = addResponse.data.file_path;
      const updatedFilePaths = [...filePaths, newFilePath];
     
      // Process files with updated paths
      const formData = new FormData();
     
      // Add empty array for files parameter
      formData.append("files", new Blob([], { type: 'application/octet-stream' }));
     
      // Add existing files
      updatedFilePaths.forEach((path) => formData.append("existing_files", path));
      formData.append("model_choice", modelChoice);
      formData.append("url", "");

      try {
        const processResponse = await axios.post("/process_files", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (processResponse.data) {
          setSummaries(processResponse.data.summaries_display || "");
          setIndividualSummaries(processResponse.data.individual_summaries || []);
          setSuggestedQuestions(processResponse.data.suggested_questions || []);
          setFilePaths(processResponse.data.file_paths || updatedFilePaths);

          // Save updated notebook data if we're in a notebook
          if (notebookId) {
            await axios.post(`/notebooks/${notebookId}/chats`, {
              chat_history: chatHistory,
              files: processResponse.data.file_paths || updatedFilePaths,
              summaries: processResponse.data.summaries_display || "",
              individual_summaries: processResponse.data.individual_summaries || [],
              suggested_questions: processResponse.data.suggested_questions || []
            });
          }
        }
      } catch (processError) {
        console.error("Error processing files:", processError);
        // Even if processing fails, we still added the note successfully
        setFilePaths(updatedFilePaths);
      }

      setNoteText("");
      setNoteStatus({
        show: true,
        message: "Note added successfully.",
        type: "success",
      });

      return {
        success: true,
        message: "Note added successfully.",
        filePath: newFilePath,
      };
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || "Unknown error occurred.";
      console.error("Error adding note:", errorMessage, error);
      setNoteStatus({
        show: true,
        message: `Failed to add note: ${errorMessage}`,
        type: "error",
      });
      return { success: false, message: `Failed to add note: ${errorMessage}` };
    } finally {
      setIsProcessing(false);
    }
  };

  const handleAddLink = async (url) => {
    if (!url || !url.trim()) {
      setNoteStatus({
        show: true,
        message: "URL cannot be empty.",
        type: "error",
      });
      return { success: false, message: "URL cannot be empty." };
    }

    try {
      setIsProcessing(true);
      const addResponse = await axios.post("/add_link", { url: url.trim() });

      if (!addResponse.data.file_path) {
        throw new Error("No file path returned from server");
      }

      const newFilePath = addResponse.data.file_path;
      const updatedFilePaths = [...filePaths, newFilePath];
     
      // Process files with updated paths
      const formData = new FormData();
     
      // Add empty array for files parameter
      formData.append("files", new Blob([], { type: 'application/octet-stream' }));
     
      // Add existing files
      updatedFilePaths.forEach((path) => formData.append("existing_files", path));
      formData.append("model_choice", modelChoice);
      formData.append("url", "");

      try {
        const processResponse = await axios.post("/process_files", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (processResponse.data) {
          setSummaries(processResponse.data.summaries_display || "");
          setIndividualSummaries(processResponse.data.individual_summaries || []);
          setSuggestedQuestions(processResponse.data.suggested_questions || []);
          setFilePaths(processResponse.data.file_paths || updatedFilePaths);

          // Save updated notebook data if we're in a notebook
          if (notebookId) {
            await axios.post(`/notebooks/${notebookId}/chats`, {
              chat_history: chatHistory,
              files: processResponse.data.file_paths || updatedFilePaths,
              summaries: processResponse.data.summaries_display || "",
              individual_summaries: processResponse.data.individual_summaries || [],
              suggested_questions: processResponse.data.suggested_questions || []
            });
          }
        }
      } catch (processError) {
        console.error("Error processing files:", processError);
        // Even if processing fails, we still added the link successfully
        setFilePaths(updatedFilePaths);
      }

      setUrl("");
      setNoteStatus({
        show: true,
        message: "Link added successfully.",
        type: "success",
      });

      return {
        success: true,
        message: "Link added successfully.",
        filePath: newFilePath,
      };
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || "Unknown error occurred.";
      console.error("Error adding link:", errorMessage, error);
      setNoteStatus({
        show: true,
        message: `Failed to add link: ${errorMessage}`,
        type: "error",
      });
      return { success: false, message: `Failed to add link: ${errorMessage}` };
    } finally {
      setIsProcessing(false);
    }
  };

  const handleProcessFiles = async () => {
    if (files.length === 0 && filePaths.length === 0) {
      setNoteStatus({
        show: true,
        message: "Please add at least one source (file, URL, or note).",
        type: "error"
      });
      return;
    }

    try {
      setIsProcessing(true);
      const formData = new FormData();

      // Append new files if any
      const regularFiles = files.filter((file) => !file.isNote);
      regularFiles.forEach((file) => formData.append("files", file));

      // Append existing files
      filePaths.forEach((path) => formData.append("existing_files", path));

      formData.append("url", "");
      formData.append("model_choice", modelChoice);

      const response = await axios.post("/process_files", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data) {
        setSummaries(response.data.summaries_display || "");
        setIndividualSummaries(response.data.individual_summaries || []);
        setSuggestedQuestions(response.data.suggested_questions || []);
        setFilePaths(response.data.file_paths || []);

        // Save updated notebook data
        if (notebookId) {
          await axios.post(`/notebooks/${notebookId}/chats`, {
            chat_history: chatHistory,
            files: response.data.file_paths || [],
            summaries: response.data.summaries_display || "",
            individual_summaries: response.data.individual_summaries || [],
            suggested_questions: response.data.suggested_questions || []
          });
        }

        setFiles([]);
        setUrl("");
        setNoteText("");
        setActiveTab("summary");
        setShowAddSourcesModal(false);
       
        setNoteStatus({
          show: true,
          message: "Files processed successfully.",
          type: "success"
        });
      }
    } catch (error) {
      console.error("Process files error:", error);
      setNoteStatus({
        show: true,
        message: `Processing error: ${error.response?.data?.detail || error.message || "Unknown error"}`,
        type: "error"
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const handleChatSubmit = async () => {
    if (!message.trim()) {
      alert("Please enter a message")
      return
    }

    try {
      setIsProcessing(true)
      setChatHistory(prev => [...prev, { user: message, ai: null }])

      const response = await axios.post("/chat", {
        message: message,
        chat_history: chatHistory.map(({ user, ai }) => [user, ai?.text || null]),
        model_choice: modelChoice,
        language_dropdown: language,
        generate_audio: generateAudio,
        notebook_id: notebookId,
      })

      const newResponse = {
        text: response.data.response || "No response",
        audio_url: response.data.audio_path
          ? `${API_URL}/audio/${response.data.audio_path.split(/[/\\]/).pop()}`
          : null,
        source_document: notebookName,
        response_id: response.data.response_id || null,  // Store response_id for implicit feedback
      }

      const updatedHistory = [...chatHistory, { user: message, ai: newResponse }]
      setChatHistory(updatedHistory)

      // Track follow-up behavior for implicit feedback
      if (chatHistory.length > 0) {
        const lastChatItem = chatHistory[chatHistory.length - 1]
        const previousResponseId = lastChatItem?.ai?.response_id
        
        if (previousResponseId) {
          // Simple heuristic: check if new message is similar to previous user message (same question)
          const previousUserMessage = lastChatItem.user?.toLowerCase().trim()
          const currentUserMessage = message.toLowerCase().trim()
          
          // Check if it's the same question (simple similarity check)
          const isSameQuestion = previousUserMessage === currentUserMessage || 
                                (previousUserMessage.length > 10 && 
                                 currentUserMessage.includes(previousUserMessage.substring(0, 10)))
          
          // Check if it's a follow-up (contains question words and is different)
          const questionWords = ['what', 'how', 'when', 'where', 'who', 'why', 'can', 'could', 'would', 'is', 'are']
          const isFollowUp = questionWords.some(word => currentUserMessage.includes(word)) && 
                            !isSameQuestion &&
                            currentUserMessage.length > 5
          
          // Calculate time since previous response (approximate)
          const timeSinceResponse = Date.now() // We could track actual time if needed
          
          if (isSameQuestion || isFollowUp) {
            trackFollowUp(previousResponseId, isSameQuestion, isFollowUp, null)
          }
        }
      }

      // Save all notebook data
      try {
        await axios.post(`/notebooks/${notebookId}/chats`, {
          chat_history: updatedHistory.map(({ user, ai }) => ({
            user,
            ai: {
              text: ai?.text || null,
              audio_url: ai?.audio_url || null,
              source_document: ai?.source_document || null
            }
          })),
          files: filePaths,
          summaries: summaries,
          individual_summaries: individualSummaries,
          suggested_questions: suggestedQuestions
        })
      } catch (saveError) {
        console.error("Error saving notebook data:", saveError)
        setNoteStatus({
          show: true,
          message: "Failed to save notebook data",
          type: "error"
        })
      }

      setMessage("")
      setSourceGuide(response.data.source_guide || "")
    } catch (error) {
      console.error("Chat error:", error)
      setChatHistory(prev => [...prev.slice(0, -1), { user: message, ai: { text: "Error responding" } }])
      setMessage("")
    } finally {
      setIsProcessing(false)
    }
  }

  const toggleAudioPlayback = (index) => {
    const audioElement = audioRefs.current[index]
    if (!audioElement) return

    if (isPlaying[index]) {
      audioElement.pause()
      setIsPlaying((prev) => ({ ...prev, [index]: false }))
    } else {
      // Track audio play event for implicit feedback
      const chatItem = chatHistory[index]
      if (chatItem?.ai?.response_id) {
        trackImplicitEvent(chatItem.ai.response_id, "audio_play", {
          timestamp: new Date().toISOString()
        })
        
        // Add event listener for audio completion
        const handleAudioEnd = () => {
          trackImplicitEvent(chatItem.ai.response_id, "audio_complete", {
            timestamp: new Date().toISOString()
          })
          audioElement.removeEventListener('ended', handleAudioEnd)
        }
        audioElement.addEventListener('ended', handleAudioEnd)
      }
      
      // Pause all other playing audio
      Object.entries(isPlaying).forEach(([key, value]) => {
        if (value && Number.parseInt(key) !== index && audioRefs.current[key]) {
          audioRefs.current[key].pause()
          setIsPlaying((prev) => ({ ...prev, [key]: false }))
        }
      })

      audioElement
        .play()
        .then(() => {
          setIsPlaying((prev) => ({ ...prev, [index]: true }))
        })
        .catch((error) => {
          console.error(`Error playing audio for index ${index}:`, error)
          setIsPlaying((prev) => ({ ...prev, [index]: false }))
        })
    }
  }

  const stopAudioPlayback = (index) => {
    const audioElement = audioRefs.current[index]
    if (audioElement) {
      audioElement.pause()
      audioElement.currentTime = 0
      setIsPlaying((prev) => ({ ...prev, [index]: false }))
      
      // Track audio completion event for implicit feedback
      const chatItem = chatHistory[index]
      if (chatItem?.ai?.response_id && audioElement.ended) {
        trackImplicitEvent(chatItem.ai.response_id, "audio_complete", {
          timestamp: new Date().toISOString()
        })
      }
    }
  }

  const handleClearChat = async () => {
    try {
      setIsProcessing(true)
      const response = await axios.post("/clear_chat")
      setChatHistory(response.data.chat_history || [])
      setSourceGuide(response.data.source_guide || "")
      setIsPlaying({})
      audioRefs.current = {}
      setIsProcessing(false)
    } catch (error) {
      console.error("Error clearing chat:", error)
      setIsProcessing(false)
    }
  }

  const handleSelectQuestion = (question) => setMessage(question)

  const handleFileMenuToggle = (index) => setShowFileMenu(showFileMenu === index ? null : index)

  const handleFileSelect = (index) => {
    setSelectedFiles((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
    setShowFileMenu(null)
  }

  const handleRenameFile = (index) => {
    setRenamingFile(index)
    setNewFileName(filePaths[index].split("/").pop())
    setShowFileMenu(null)
    // Focus the rename input after it renders
    setTimeout(() => {
      if (renameInputRef.current) {
        renameInputRef.current.focus()
        renameInputRef.current.select()
      }
    }, 10)
  }

  const saveNewFileName = async () => {
    if (!newFileName.trim()) {
      return
    }

    try {
      // Just update the display for now since backend renaming is not implemented
      // This would be where you'd make an API call to rename the file on the server
      const oldPath = filePaths[renamingFile]
      const fileDir = oldPath.substring(0, oldPath.lastIndexOf("/") + 1)
      const newPath = fileDir + newFileName

      // Update the file path in state
      const updatedFilePaths = [...filePaths]
      updatedFilePaths[renamingFile] = newPath
      setFilePaths(updatedFilePaths)

      setRenamingFile(null)
      setNewFileName("")

      setNoteStatus({
        show: true,
        message: "File renamed successfully.",
        type: "success",
      })
    } catch (error) {
      console.error("Error renaming file:", error)
      setNoteStatus({
        show: true,
        message: `Error renaming file: ${error.message}`,
        type: "error",
      })
    }
  }

  const handleRenameInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      saveNewFileName()
    } else if (e.key === "Escape") {
      setRenamingFile(null)
      setNewFileName("")
    }
  }

  const handleDeleteFiles = async () => {
    try {
      setIsProcessing(true);

      // Delete the selected files
      const filesToDelete = selectedFiles.map((index) => filePaths[index]);

      // Make API call to delete files
      await axios.post("/delete_files", {
        file_paths: filesToDelete,
      });

      // Update local state by removing deleted files
      const updatedFilePaths = filePaths.filter((_, index) => !selectedFiles.includes(index));
      setFilePaths(updatedFilePaths);
      setSelectedFiles([]);
      setShowDeleteConfirm(false);

      // If there are still files left, regenerate summaries
      if (updatedFilePaths.length > 0) {
        // Create FormData for processing remaining files
        const formData = new FormData();
        updatedFilePaths.forEach((path) => formData.append("existing_files", path));
        formData.append("model_choice", modelChoice);

        // Process the remaining files
        const processResponse = await axios.post("/process_files", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        // Update summaries and questions with new data
        setSummaries(processResponse.data.summaries_display || "");
        setIndividualSummaries(processResponse.data.individual_summaries || []);
        setSuggestedQuestions(processResponse.data.suggested_questions || []);

        // Save updated notebook data if we're in a notebook
        if (notebookId) {
          await axios.post(`/notebooks/${notebookId}/chats`, {
            chat_history: chatHistory,
            files: updatedFilePaths,
            summaries: processResponse.data.summaries_display || "",
            individual_summaries: processResponse.data.individual_summaries || [],
            suggested_questions: processResponse.data.suggested_questions || []
          });
        }

        setNoteStatus({
          show: true,
          message: "Files deleted and summaries updated successfully.",
          type: "success",
        });
      } else {
        // If no files left, clear all summaries
        setSummaries("");
        setIndividualSummaries([]);
        setSuggestedQuestions([]);

        setNoteStatus({
          show: true,
          message: "All files deleted. Please add new files to generate summaries.",
          type: "info",
        });
      }

      setIsProcessing(false);
    } catch (error) {
      console.error("Error deleting files:", error);
      setNoteStatus({
        show: true,
        message: `Error deleting files: ${error.response?.data?.detail || error.message}`,
        type: "error",
      });
      setIsProcessing(false);
    }
  };

  const AddSourcesModal = () => {
    if (!showAddSourcesModal) return null

    const handleSubmit = async () => {
      try {
        setIsProcessing(true)

        // Handle note addition if present
        if (noteText.trim()) {
          const noteResult = await handleAddNote(noteText)
          if (!noteResult.success) return
        }

        // Handle link addition if present
        if (url.trim()) {
          const linkResult = await handleAddLink(url)
          if (!linkResult.success) return
        }

        // Process all sources (files, notes, and links) together
        await handleProcessFiles()
      } catch (error) {
        console.error("Error in handleSubmit:", error)
        setNoteStatus({
          show: true,
          message: `Error processing sources: ${error.message}`,
          type: "error",
        })
      } finally {
        setIsProcessing(false)
      }
    }

    return (
      <div className="modal-overlay">
        <div className="add-sources-modal">
          <div className="modal-header">
            <h2>Add Sources</h2>
            <button className="close-button" onClick={() => setShowAddSourcesModal(false)}>
              ×
            </button>
          </div>
          <div className="modal-content" ref={modalContentRef}>
            <div className="supported-files">
              <p>Supported files type: PDF, DOC, DOCX, XLS, XLSX, CSV, MP3, WAV, TXT</p>
              <div className="file-icons">
                <span className="file-icon pdf">PDF</span>
                <span className="file-icon doc">DOC</span>
                <span className="file-icon audio">MP3</span>
                <span className="file-icon word">DOCX</span>
                <span className="file-icon excel">XLS</span>
              </div>
            </div>
            <div className="source-limit">Source limit: {files.length}/20</div>
            <div className="upload-area">
              <div className="upload-zone" onClick={() => fileInputRef.current?.click()}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" fill="currentColor" />
                </svg>
                <p>Upload Sources</p>
                <p className="upload-hint">Drag & drop or choose files to upload</p>
              </div>
              <input type="file" multiple ref={fileInputRef} onChange={handleFileChange} className="hidden-input" />
              {files.length > 0 && (
                <div className="uploaded-files">
                  <h4>Selected Files:</h4>
                  {files.map((file, index) => (
                    <div key={index} className="uploaded-file-item">
                      <span>
                        {file.name} {file.isNote ? " (Note)" : ""}
                      </span>
                      <button onClick={() => setFiles(files.filter((_, i) => i !== index))} className="remove-file">
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="url-input-section">
              <input type="text" placeholder="Paste any link" value={url} onChange={(e) => setUrl(e.target.value)} />
              <button
                className="add-to-source-button"
                onClick={() => handleAddLink(url)}
                disabled={isProcessing || !url.trim()}
              >
                Add to Source
              </button>
            </div>
            <div className="notes-input-section">
              <textarea placeholder="Add notes..." value={noteText} onChange={(e) => setNoteText(e.target.value)} />
              <button
                className="add-to-source-button"
                onClick={() => handleAddNote(noteText)}
                disabled={isProcessing || !noteText.trim()}
              >
                Add to Source
              </button>
            </div>
            {noteStatus.show && <div className={`note-status-message ${noteStatus.type}`}>{noteStatus.message}</div>}
            <div className="modal-actions">
              <button className="process-button" onClick={handleSubmit} disabled={isProcessing}>
                {isProcessing ? "Processing..." : "Process"}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const [editingIndex, setEditingIndex] = useState(null)
  const [editedResponse, setEditedResponse] = useState("")

  const handleEditResponse = (index) => {
    const responseToEdit = chatHistory[index].ai?.text || ""
    setEditedResponse(responseToEdit)
    setEditingIndex(index)
  }

  const saveEditedResponse = () => {
    if (editingIndex !== null) {
      const updatedHistory = [...chatHistory]
      if (updatedHistory[editingIndex].ai && typeof updatedHistory[editingIndex].ai === "object") {
        // Preserve the source document and audio URL
        const sourceDocument = updatedHistory[editingIndex].ai.source_document || "Unknown Source"
        const audioUrl = updatedHistory[editingIndex].ai.audio_url || null
        updatedHistory[editingIndex].ai = {
          text: editedResponse,
          audio_url: audioUrl,
          source_document: sourceDocument,
        }
      } else {
        updatedHistory[editingIndex].ai = {
          text: editedResponse,
          source_document: "Unknown Source",
        }
      }
      setChatHistory(updatedHistory)
      setEditingIndex(null)
      setEditedResponse("")
    }
  }

  const cancelEdit = () => {
    setEditingIndex(null)
    setEditedResponse("")
  }

  // Function to remove summary heading and content
  const removeSummarySection = (text) => {
    // Regular expression to match "## Summary" or "Summary" heading and all content after it until the end of the text
    // or until another heading starts
    return text.replace(/(?:\r?\n)*(?:##?\s*Summary|\bSummary\b)(?:\r?\n)*([\s\S]*?)(?=(?:\r?\n)+##?|\s*$)/gi, "")
  } // Add the missing closing curly brace and semicolon here

  const handleNewChat = () => {
    // Create a new notebook with default name
    createNewNotebook("Untitled Notebook")
    // Clear chat history and source guide
    handleClearChat()
    // Close sidebar if on mobile
    if (window.innerWidth <= 768) {
      setSidebarOpen(false)
    }
  }

  const createNewNotebook = async (title) => {
    try {
      const response = await axios.post("/create_notebook", {
        title: title || "Untitled Notebook",
      })

      if (response.data.status === "success") {
        setNotebookId(response.data.notebook_id)
        setNotebookName(title || "Untitled Notebook")

        // Refresh chat sessions
        const notebooksResponse = await axios.get("/recent_notebooks")
        if (notebooksResponse.data.status === "success") {
          setLoadedChatSessions(notebooksResponse.data.notebooks)
        }
      }
    } catch (error) {
      console.error("Error creating notebook:", error)
    }
  }

  const handleSaveNotebookName = async () => {
    if (!notebookName.trim()) {
      setNotebookName("Untitled Notebook")
    }

    try {
      // Here you would make an API call to update the notebook name in your backend
      // For now, we'll just update the local state
      setIsEditingNotebookName(false)

      if (notebookId) {
        // This would be where you'd make an API call to update the notebook name
        console.log(`Updated notebook ${notebookId} name to ${notebookName}`)

        // Update in the chat history responses
        const updatedChatHistory = chatHistory.map((chat) => {
          if (chat.ai && typeof chat.ai === "object") {
            return {
              ...chat,
              ai: {
                ...chat.ai,
                source_document: notebookName,
              },
            }
          }
          return chat
        })

        setChatHistory(updatedChatHistory)

        setNoteStatus({
          show: true,
          message: "Notebook name updated",
          type: "success",
        })
      }
    } catch (error) {
      console.error("Error saving notebook name:", error)
      setNoteStatus({
        show: true,
        message: "Failed to update notebook name",
        type: "error",
      })
    }
  }

  const handleNotebookNameKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      handleSaveNotebookName()
    } else if (e.key === "Escape") {
      setIsEditingNotebookName(false)
      // Revert to the previous name
      if (notebookId) {
        // If there was an existing name, keep it
      } else {
        setNotebookName("Untitled Notebook")
      }
    }
  }

  useEffect(() => {
    const fetchChatSessions = async () => {
      if (!isAuthenticated) return

      try {
        const response = await axios.get("/recent_notebooks")
        if (response.data.status === "success") {
          setLoadedChatSessions(response.data.notebooks)

          // If there are chat sessions and no active notebook,
          // select the most recent one
          if (response.data.notebooks.length > 0 && !notebookId) {
            const mostRecent = response.data.notebooks[0]
            setNotebookId(mostRecent.id)
            setNotebookName(mostRecent.title)
          }
        }
      } catch (error) {
        console.error("Error fetching chat sessions:", error)
      }
    }

    fetchChatSessions()
  }, [isAuthenticated, notebookId])

  // Update notebook selection effect
  useEffect(() => {
    if (!notebookId || !loadedChatSessions.length) return

    const notebook = loadedChatSessions.find((n) => n.id === notebookId)
    if (notebook) {
      setNotebookName(notebook.title)
    }
  }, [notebookId, loadedChatSessions])

  // Update initialization effect
  useEffect(() => {
    const initializeNotebook = async () => {
      if (isAuthenticated && !notebookId && !loadedChatSessions.length) {
        await createNewNotebook("Untitled Notebook")
      }
    }

    initializeNotebook()
  }, [isAuthenticated, notebookId, loadedChatSessions])

  if (!isAuthenticated) {
    return (
      <AuthPage
        onAuthSuccess={(userData) => {
          setUser(userData)
          setIsAuthenticated(true)
          setShowWelcome(true)
        }}
      />
    )
  }

  if (showWelcome) {
    return (
      <WelcomePage
        user={user}
        onAddNotes={() => {
          setShowWelcome(false)
          setShowAddSourcesModal(true)
        }}
        setShowWelcome={setShowWelcome}
        loadChatSession={loadChatSession}
        setNoteStatus={setNoteStatus}
      />
    )
  }

  const SourcesPanel = () => (
    <div className={`sources-panel ${sidebarOpen ? "open" : "closed"}`}>
      <div className="panel-header">
        {sidebarOpen && (
          <>
            {isEditingNotebookName ? (
              <div className="notebook-name-editor">
                <input
                  type="text"
                  value={notebookName}
                  onChange={(e) => setNotebookName(e.target.value)}
                  onBlur={handleSaveNotebookName}
                  onKeyDown={handleNotebookNameKeyDown}
                  autoFocus
                  className="notebook-name-input"
                  placeholder="Enter notebook name"
                />
              </div>
            ) : (
              <div className="notebook-name" onClick={() => setIsEditingNotebookName(true)}>
                <h2>{notebookName}</h2>
                <button className="edit-notebook-name" aria-label="Edit notebook name">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            )}
          </>
        )}
        <button className="hamburger-menu" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </div>
      {sidebarOpen && (
        <>
          <button className="new-chat-btn" onClick={handleNewChat}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 8v4M8 12h8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            New Chat
          </button>
          <button className="add-sources-button" onClick={() => setShowAddSourcesModal(true)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 5V19M5 12H19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Add Sources
          </button>

          {/* Chat History Section */}
          {loadedChatSessions.length > 0 && (
            <div className="chat-sessions">
              <h3>Recent Chats</h3>
              <div className="chat-sessions-list">
                {loadedChatSessions.map((session) => (
                  <div
                    key={session.id}
                    className={`chat-session-item ${notebookId === session.id ? "active" : ""}`}
                    onClick={() => loadChatSession(session.id, session.title)}
                  >
                    <span className="chat-session-title">{session.title}</span>
                    <span className="chat-session-date">{session.created_at}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="file-list">
            {filePaths.map((path, index) => (
              <div key={index} className={`file-item ${selectedFiles.includes(index) ? "selected" : ""}`}>
                <svg
                  className={`file-item ${selectedFiles.includes(index) ? "selected" : ""}`}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                    fill="#FF5722"
                  />
                  <path d="M14 2V8H20L14 2Z" fill="#FBE9E7" />
                </svg>
                {renamingFile === index ? (
                  <input
                    ref={renameInputRef}
                    type="text"
                    className="rename-input"
                    value={newFileName}
                    onChange={(e) => setNewFileName(e.target.value)}
                    onBlur={saveNewFileName}
                    onKeyDown={handleRenameInputKeyDown}
                  />
                ) : (
                  <span>{path.split("/").pop()}</span>
                )}

                <div className="file-menu-container">
                  <button className="file-menu-button" onClick={() => handleFileMenuToggle(index)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  {showFileMenu === index && (
                    <div className="file-menu-dropdown">
                      <button onClick={() => handleRenameFile(index)}>Rename</button>
                      <button onClick={() => handleFileSelect(index)}>
                        {selectedFiles.includes(index) ? "Deselect" : "Select for deletion"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {selectedFiles.length > 0 && (
            <div className="delete-controls">
              <button onClick={() => setShowDeleteConfirm(true)} className="delete-button">
                Delete Selected ({selectedFiles.length})
              </button>
              <button onClick={() => setSelectedFiles([])} className="cancel-button">
                Cancel
              </button>
            </div>
          )}
        </>
      )}
    </div>
  )

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="logo" onClick={() => setShowWelcome(true)} style={{ cursor: 'pointer' }}>
          <img
            src="https://media.licdn.com/dms/image/v2/D560BAQGF6NHHgadKYg/company-logo_200_200/company-logo_200_200/0/1707117426803?e=2147483647&v=beta&t=HsOE6G-9_879EDgNxvhQdr9Sgk2Tyyn_qUY1jV6jdXA"
            alt="Synapze Logo"
            className="custom-logo"
          />
          <h1>SynapzeLM</h1>
        </div>
        <div className="header-controls">
          <div className="model-selector">
            <select value={modelChoice} onChange={(e) => setModelChoice(e.target.value)} disabled={isProcessing}>
              <option value="gemma-4b">Gemma 4B (default)</option>
              <option value="gemini-2.0-flash">gemini-2.0-flash</option>
              <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>
              <option value="groq-mixtral">Groq Mixtral</option>
              <option value="claude">Claude</option>
              <option value="mistral">mistral</option>
            </select>
          </div>
          <div className="language-selector">
            <select value={language} onChange={(e) => setLanguage(e.target.value)} disabled={isProcessing}>
              <option value="en">English</option>
              <option value="hi">Hindi</option>
              <option value="kn">Kannada</option>
              <option value="te">Telugu</option>
              <option value="mr">Marathi</option>
              <option value="gu">Gujarati</option>
              <option value="pa">Punjabi</option>
              <option value="ml">Malayalam</option>
            </select>
          </div>
          <div className="user-profile-header">
            <img
              src="https://cdn-icons-png.flaticon.com/512/9385/9385289.png"
              alt="User Profile"
              className="user-profile-image"
            />
            <span className="user-email">{user?.email}</span>
          </div>
          <div className="settings-dropdown">
            <button className="settings-btn">Settings</button>
            <div className="settings-menu">
              <button onClick={() => alert("LLM Config")}>LLM Config</button>
              <button onClick={() => alert("LLM Fine Tune")}>LLM Fine Tune</button>
              <button onClick={() => alert("AI Agents Selection")}>AI Agents Selection</button>
              <button onClick={handleLogout}>Logout</button>
            </div>
          </div>
        </div>
      </header>

      <div className="main-content">
        {/* Left Panel: Sources */}
        <div className={`sources-panel ${sidebarOpen ? "open" : "closed"}`}>
          <div className="panel-header">
            {sidebarOpen && (
              <>
                {isEditingNotebookName ? (
                  <div className="notebook-name-editor">
                    <input
                      type="text"
                      value={notebookName}
                      onChange={(e) => setNotebookName(e.target.value)}
                      onBlur={handleSaveNotebookName}
                      onKeyDown={handleNotebookNameKeyDown}
                      autoFocus
                      className="notebook-name-input"
                      placeholder="Enter notebook name"
                    />
                  </div>
                ) : (
                  <div className="notebook-name" onClick={() => setIsEditingNotebookName(true)}>
                    <h2>{notebookName}</h2>
                    <button className="edit-notebook-name" aria-label="Edit notebook name">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                          fill="currentColor"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </>
            )}
            <button className="hamburger-menu" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          </div>
          {sidebarOpen && (
            <>
              <button className="new-chat-btn" onClick={handleNewChat}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 8v4M8 12h8"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>New Chat</span>
              </button>
              <button className="add-sources-button" onClick={() => setShowAddSourcesModal(true)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 5V19M5 12H19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Add Sources</span>
              </button>

              {/* Chat History Section */}
              {loadedChatSessions.length > 0 && (
                <div className="chat-sessions">
                  <h3>Recent Chats</h3>
                  <div className="chat-sessions-list">
                    {loadedChatSessions.map((session) => (
                      <div
                        key={session.id}
                        className={`chat-session-item ${notebookId === session.id ? "active" : ""}`}
                        onClick={() => loadChatSession(session.id, session.title)}
                      >
                        <span className="chat-session-title">{session.title}</span>
                        <span className="chat-session-date">{session.created_at}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="file-list">
                {filePaths.map((path, index) => (
                  <div key={index} className={`file-item ${selectedFiles.includes(index) ? "selected" : ""}`}>
                    <svg
                      className={`file-item ${selectedFiles.includes(index) ? "selected" : ""}`}
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                        fill="#FF5722"
                      />
                      <path d="M14 2V8H20L14 2Z" fill="#FBE9E7" />
                    </svg>
                    {renamingFile === index ? (
                      <input
                        ref={renameInputRef}
                        type="text"
                        className="rename-input"
                        value={newFileName}
                        onChange={(e) => setNewFileName(e.target.value)}
                        onBlur={saveNewFileName}
                        onKeyDown={handleRenameInputKeyDown}
                      />
                    ) : (
                      <span>{path.split("/").pop()}</span>
                    )}

                    <div className="file-menu-container">
                      <button className="file-menu-button" onClick={() => handleFileMenuToggle(index)}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                      {showFileMenu === index && (
                        <div className="file-menu-dropdown">
                          <button onClick={() => handleRenameFile(index)}>Rename</button>
                          <button onClick={() => handleFileSelect(index)}>
                            {selectedFiles.includes(index) ? "Deselect" : "Select for deletion"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {selectedFiles.length > 0 && (
                <div className="delete-controls">
                  <button onClick={() => setShowDeleteConfirm(true)} className="delete-button">
                    Delete Selected ({selectedFiles.length})
                  </button>
                  <button onClick={() => setSelectedFiles([])} className="cancel-button">
                    Cancel
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* Center Panel: Chat */}
        <div className="content-panel">
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === "summary" ? "active" : ""}`}
              onClick={() => setActiveTab("summary")}
            >
              Summary
            </button>
            <button
              className={`tab-button ${activeTab === "chat" ? "active" : ""}`}
              onClick={() => setActiveTab("chat")}
            >
              Chat
            </button>
          </div>

          <div className={`tab-content ${activeTab === "summary" ? "active" : ""}`}>
            {summaries ? (
              <div className="summary-container">
                <div className="combined-summary">
                  <h3>Combined Summary</h3>
                  <div className="summary-content">
                    <ReactMarkdown>{summaries}</ReactMarkdown>
                  </div>
                </div>
                {individualSummaries.length > 0 && (
                  <div className="individual-summaries">
                    <h3>Individual Summaries</h3>
                    <div className="summaries-scroll-container">
                      {individualSummaries.map((summary, index) => (
                        <div key={index} className="individual-summary-item">
                          <h4>{summary.filename}</h4>
                          <div className="summary-content">
                            <ReactMarkdown>{summary.summary}</ReactMarkdown>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="empty-state"></div>
            )}
          </div>

          <div className={`tab-content ${activeTab === "chat" ? "active" : ""}`}>
            <div className="chat-history" ref={chatHistoryRef}>
              {chatHistory.length === 0 ? (
                <div className="welcome-message" style={{ textAlign: "center" }}>
                  <h3>Welcome to SynapzeLM</h3>
                </div>
              ) : (
                <ChatTabContent
                  chatHistory={chatHistory}
                  audioRefs={audioRefs}
                  isPlaying={isPlaying}
                  toggleAudioPlayback={toggleAudioPlayback}
                  stopAudioPlayback={stopAudioPlayback}
                  setActiveAudioIndex={setActiveAudioIndex}
                />
              )}
            </div>

            {suggestedQuestions.length > 0 && (
              <div className="suggested-questions">
                <h3>Suggested Questions:</h3>
                <div className="question-list" id="suggested-questions" style={{ marginTop: "10px" }}>
                  {suggestedQuestions.map((q, i) => (
                    <button
                      key={i}
                      onClick={() => handleSelectQuestion(q)}
                      disabled={isProcessing}
                      className="question-button"
                    >
                      {q}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="chat-input-area">
              <div className="input-container">
                <textarea
                  id="message-input"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Enter your question and send"
                  disabled={isProcessing}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault()
                      handleChatSubmit()
                    }
                  }}
                />
                <button onClick={handleChatSubmit} disabled={isProcessing} className="send-button">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="white" />
                  </svg>
                </button>
              </div>
              <div className="chat-controls">

                <button onClick={handleClearChat} disabled={isProcessing} className="clear-button">
                  Clear Chat
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel: Audio Response */}
        <div className="audio-panel">
          <div className="audio-panel-header">
            <div className="audio-panel-title">Audio Response</div>
          </div>
          <div className="audio-panel-content">
            {activeAudioIndex !== null && chatHistory[activeAudioIndex]?.ai?.audio_url ? (
              <AudioControls
                audioUrl={chatHistory[activeAudioIndex].ai.audio_url}
                index={activeAudioIndex}
                isPlaying={isPlaying}
                toggleAudioPlayback={toggleAudioPlayback}
                stopAudioPlayback={stopAudioPlayback}
                audioRefs={audioRefs}
                sourceInfo={chatHistory[activeAudioIndex].ai.source_document || "Unknown Source"}
              />
            ) : (
              <div className="no-audio-message">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                  <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
                </svg>
                <p>No audio response selected</p>
                <p>Click the audio icon on a message to play it here</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <AddSourcesModal />

      {showDeleteConfirm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete {selectedFiles.length} file(s)?</p>
            <div className="modal-actions">
              <button onClick={handleDeleteFiles} className="delete-confirm-button">
                Yes, Delete
              </button>
              <button onClick={() => setShowDeleteConfirm(false)} className="cancel-button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {noteStatus.show && <div className={`floating-notification ${noteStatus.type}`}>{noteStatus.message}</div>}
    </div>
  )
}

export default App;
